export default {"src":"/_next/static/media/tiktok-icon.a35dd94a.svg","height":20,"width":18,"blurWidth":0,"blurHeight":0};